import { fromJS } from 'immutable';
import { resolveErrors } from '../../../../components/grid/resultGridUtils';
import { visibleColumns } from './volcanoLocationReduxConstants';

export const CLEAR_VOLCANO_LOCATION_DATA = 'CLEAR_VOLCANO_LOCATION_DATA';

export const DELETE_VOLCANO_LOCATION_REQUEST = 'DELETE_VOLCANO_LOCATION_REQUEST';
export const DELETE_VOLCANO_LOCATION_SUCCESS = 'DELETE_VOLCANO_LOCATION_SUCCESS';
export const DELETE_VOLCANO_LOCATION_FAILURE = 'DELETE_VOLCANO_LOCATION_FAILURE';

export const GET_VOLCANO_LOCATION_DATA_REGION_REQUEST = 'GET_VOLCANO_LOCATION_DATA_REGION_REQUEST';
export const GET_VOLCANO_LOCATION_DATA_REGION_SUCCESS = 'GET_VOLCANO_LOCATION_DATA_REGION_SUCCESS';
export const GET_VOLCANO_LOCATION_DATA_REGION_FAILURE = 'GET_VOLCANO_LOCATION_DATA_REGION_FAILURE';

export const VOLCANO_LOCATION_DATA_SAVE_OPEN_CONFIRMATION = 'VOLCANO_LOCATION_DATA_SAVE_OPEN_CONFIRMATION';
export const VOLCANO_LOCATION_DATA_SAVE_CANCEL_CONFIRMATION = 'VOLCANO_LOCATION_DATA_SAVE_CANCEL_CONFIRMATION';
export const VOLCANO_LOCATION_DATA_CANCEL_EDIT = 'VOLCANO_LOCATION_DATA_CANCEL_EDIT';
export const VOLCANO_LOCATION_DATA_EDIT = 'VOLCANO_LOCATION_DATA_EDIT';
export const VOLCANO_LOCATION_DATA_BULK_EDIT_REQUEST = 'VOLCANO_LOCATION_DATA_BULK_EDIT_REQUEST';
export const VOLCANO_LOCATION_DATA_BULK_EDIT_SUCCESS = 'VOLCANO_LOCATION_DATA_BULK_EDIT_SUCCESS';
export const VOLCANO_LOCATION_DATA_BULK_EDIT_FAILURE = 'VOLCANO_LOCATION_DATA_BULK_EDIT_FAILURE';

export const VOLCANO_LOCATION_DATA_TOGGLE_COLUMN = 'VOLCANO_LOCATION_DATA_TOGGLE_COLUMN';

const initialState = fromJS({
  deleting: false,
  visibleColumns,
  fetchedRegions: false,
  regions: [],
  saving: false,
  formData: {},
  initialFormData: {},
  editConfirmationOpen: false,
  errors: {},
  editing: false,
  initialValues: {},
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const volcanoLocationDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case VOLCANO_LOCATION_DATA_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: true,
        initialValues: action.initialValues,
      }));
    case VOLCANO_LOCATION_DATA_CANCEL_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: false,
        initialValues: {},
      }));

    case VOLCANO_LOCATION_DATA_SAVE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        initialFormData: action.initialFormData,
        editConfirmationOpen: true,
      }));
    case VOLCANO_LOCATION_DATA_SAVE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        initialFormData: {},
        editConfirmationOpen: false,
      }));

    case VOLCANO_LOCATION_DATA_BULK_EDIT_REQUEST:
      return state.merge(fromJS({
        saving: true,
        errors: {},
      }));
    case VOLCANO_LOCATION_DATA_BULK_EDIT_SUCCESS:
      return state.merge(fromJS({
        saving: false,
        errors: {},
      }));
    case VOLCANO_LOCATION_DATA_BULK_EDIT_FAILURE:
      return state.merge(fromJS({
        saving: false,
        errors: resolveErrors(action.response),
      }));


    case CLEAR_VOLCANO_LOCATION_DATA:
      return initialState.merge(fromJS({
        visibleColumns: state.get('visibleColumns'),
      }));

    case VOLCANO_LOCATION_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case DELETE_VOLCANO_LOCATION_REQUEST:
      return state.merge(fromJS({
        deleting: true,
      }));
    case DELETE_VOLCANO_LOCATION_SUCCESS:
    case DELETE_VOLCANO_LOCATION_FAILURE:
      return state.merge(fromJS({
        deleting: false,
      }));

    case GET_VOLCANO_LOCATION_DATA_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case GET_VOLCANO_LOCATION_DATA_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case GET_VOLCANO_LOCATION_DATA_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    default:
      return state;
  }
};
